import {
  registerCompareFunctionFactory,
  getCompareFunctionFactory,
  registerRootComparator,
  getRootComparator
} from './registry';

import {
  compareFunctionFactory as defaultSort,
  COLUMN_DATA_TYPE as DEFAULT_DATA_TYPE
} from '../sortFunction/default';

import {
  compareFunctionFactory as numericSort,
  COLUMN_DATA_TYPE as NUMERIC_DATA_TYPE
} from '../sortFunction/numeric';

import {
  FIRST_AFTER_SECOND,
  FIRST_BEFORE_SECOND,
  DO_NOT_SWAP,
  sort
} from './engine';

registerCompareFunctionFactory(NUMERIC_DATA_TYPE, numericSort);
registerCompareFunctionFactory(DEFAULT_DATA_TYPE, defaultSort);

export {
  registerRootComparator,
  getRootComparator,
  getCompareFunctionFactory,
  FIRST_AFTER_SECOND,
  FIRST_BEFORE_SECOND,
  DO_NOT_SWAP,
  sort
};
